<button mat-icon-button (click)="scanQRCode()">
  <ion-icon name="qr-code-outline" class="text-3xl"></ion-icon>
</button>
